// Build-time feature flags. Kept separate from the per-user `FeatureKey`
// system (see src/shared/types/features.ts) which is org-scoped and driven
// by BrandFeatureConfig. These are Vite env flags that gate whole v3
// slices of the app during rollout — flipped on in staging first, then
// prod, then removed once the slice is stable.
//
// Read at import time so the constant is inlined by Vite; toggling a flag
// requires a rebuild.

const truthy = (v: string | boolean | undefined): boolean =>
  v === true || v === 'true' || v === '1';

/**
 * `newsroom.v3` — per-brand Newsroom editor. Registers the `/app/newsroom`
 * route. On in staging/prod builds (.github/workflows/_build-artifacts.yml)
 * and by default in DEV. Its roadmap step stays a preview until b2b-api
 * serves PUBLISH_NEWSROOM (see programs/registry).
 */
export const NEWSROOM_V3_ENABLED: boolean =
  truthy(import.meta.env.VITE_NEWSROOM_V3) || import.meta.env.DEV === true;
